var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8534 11.3333C21.8534 11.3333 20.7504 2 11.9267 2C3.10297 2 2 11.3333 2 11.3333",
    stroke: "#34C759",
    strokeWidth: 2.33333,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9265 15.9998C14.3631 15.9998 16.3384 13.9105 16.3384 11.3332C16.3384 8.75584 14.3631 6.6665 11.9265 6.6665C9.48991 6.6665 7.51465 8.75584 7.51465 11.3332C7.51465 13.9105 9.48991 15.9998 11.9265 15.9998Z",
    fill: "#34C759"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeicon);
export default __webpack_public_path__ + "static/media/eyeicon.bc800d3cf94f2cef128a079255dd2b5c.svg";
export { ForwardRef as ReactComponent };